app.service('companyName', function (_, console, validate) {

	function prepare(value) {
		const cleanedValue = clean(value);
		return [
			cleanedValue,
			cleanedValue.substring(0, 80),
			cleanedValue.substring(80, 160)
		];
	}

	function clean(input) {
		return _.normalizeSpace(input.replace(/(<([^>]+)>)/g, ''));
	}

	function handleInput($div, $textarea, $input1, $input2, $form) {
		const value = prepare($div.text());
		$textarea.val(value[0]);
		$input1.val(value[1]);
		$input2.val(value[2]);

		validate.element($textarea, $form);
	}

	function handlePaste(event) {
		event.preventDefault();
		const text = (event.originalEvent || event).clipboardData.getData('text/plain');
		const normalizedText = clean(text);
		document.execCommand('insertText', false, normalizedText);
	}

	function init(prefix) {
		const $input1 = $(`#${prefix}`);
		if (!$input1.length) return;

		const $input2 = $(`#${prefix}-cd`);
		const $textarea = $(`#${prefix}-textarea`);
		const $div = $(`#${prefix}-textarea-div`);
		const $form = $input1.closest('form');

		$input1.ignore(true);
		$input2.ignore(true);

		$div
			.on('input', () => handleInput($div, $textarea, $input1, $input2, $form))
			.on('focus', function () {
				$(this).closest('.column').addClass('input-focus');
			})
			.on('blur', function () {
				$(this).closest('.column').removeClass('input-focus');
				validate.element($textarea, $form);
			})
			.on('paste', handlePaste);
	}

	function setValue($textarea, value) {
		if ($textarea && $textarea.length) {
			const id = $textarea.attr('id');
			$('#' + id + '-div').text(value).trigger('input').closest('.validate-error').removeClass('validate-error');
			$('#' + id + '-error').remove();
		} else {
			console.log('Brak pola firmy do zmiany');
		}
	}

	return { init, setValue };
});
